<template>
  <div class="demandReport" id="demandReport">
    <div class="leftDiv">
      <div class="leftTopDiv">
        <div class="userInfoClass">
          <div class="photo">
            <img v-if="userInfo.iconUrl" :src="userInfo.iconUrl" />
          </div>
          <div class="basicInfo">
            <tooltip-over
              :content="userInfo.username"
              :className="'username'"
              class="wid190"
              refName="username"
            ></tooltip-over>
            <div class="line"></div>
            <tooltip-over
              :content="'账号:' + userInfo.userNo"
              :className="'userNo'"
              class="wid190"
              refName="userNo"
            ></tooltip-over>
            <tooltip-over
              :content="userInfo.departmentName"
              :className="'departmentName'"
              class="wid190"
              refName="departmentName"
            ></tooltip-over>
            <tooltip-over
              :content="userInfo.roleName"
              :className="'roleName'"
              class="wid190"
              refName="roleName"
            ></tooltip-over>
          </div>
          <div class="logOut" @click="logOut()"></div>
        </div>
        <div class="statistics">
          <div
            class="newTask"
            :style="opacityInfos.opacityOfNewTask"
            @click="newTask"
          >
            <div class="title">新任务</div>
            <div class="num">{{ numInfos.newTaskNum }}</div>
          </div>
          <div
            class="planning"
            :style="opacityInfos.opacityOfPlanning"
            @click="planning"
          >
            <div class="title">规划中</div>
            <div class="num">{{ numInfos.planningNum }}</div>
          </div>
          <div
            class="submitted"
            :style="opacityInfos.opacityOfSubmitted"
            @click="submitted"
          >
            <div class="title">已提交</div>
            <div class="num">{{ numInfos.submittedNum }}</div>
          </div>
          <div
            class="rejected"
            :style="opacityInfos.opacityOfRejected"
            @click="rejected"
          >
            <div class="title">驳回</div>
            <div class="num">{{ numInfos.rejectedNum }}</div>
          </div>
        </div>
      </div>
      <div class="leftBottomDiv">
        <div class="contentClass">
          <!-- <div class="title">任务总数</div> -->
          <div class="taskListCommonTableContainer">
            <el-table
              :data="newTaskList"
              @row-click="clickTaskRow"
              ref="newTaskList"
              height="384"
              style="width: 100%"
              class="taskPlanCommonTable"
              tooltip-effect="light"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                prop="local_id"
                label="任务编号"
                align="center"
                min-width="90"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="mission_name"
                label="任务名称"
                align="center"
                min-width="90"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="priority"
                label="优先级"
                align="center"
                min-width="65"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span class="prioritySpan" v-if="scope.row.priority === 1"
                    >低</span
                  >
                  <span
                    class="prioritySpan"
                    v-else-if="scope.row.priority === 2"
                    >中</span
                  >
                  <span class="prioritySpan" v-else>高</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="mission_status"
                label="当前状态"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.mission_status === 10">待取货</span>
                  <span v-else-if="scope.row.mission_status === 20"
                    >完成取货</span
                  >
                  <span v-else-if="scope.row.mission_status === 90"
                    >任务完成</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="surplus_goods_count"
                label="货物余量"
                align="center"
              >
                <template slot-scope="scope">
                  <span class="prioritySpan">{{scope.row.surplus_goods_count}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="searchArea">
            <div class="desc">任务搜索</div>
            <div class="separate"></div>
            <el-form :model="queryTaskForm" @submit.native.prevent>
              <el-form-item label="">
                <el-input
                  class="inputClass"
                  v-model="queryTaskForm.mission_name"
                  @keyup.enter.native="queryTaskByCondition()"
                >
                  <i
                    class="el-icon-search-img"
                    slot="suffix"
                    @click="queryTaskByCondition()"
                  >
                  </i></el-input
              ></el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="centerDiv" v-show="newTaskDemandDisplay">
      <div class="centerTopDiv">
        <div class="formTitle">
          <div class="taskIcon">
            <el-image :src="taskIcon" class="icon" />
          </div>
          <div class="taskInfo">
            <div class="descOfNo">任务编号</div>
            <div class="line"></div>
            <div class="taskNo">{{ taskForm.local_id }}</div>
          </div>
          <div class="barCodeDiv">
            <img id="barCode" class="barCode" v-show="isDetail" />
          </div>
        </div>
        <div v-show="isDetail">
          <div class="seperate"></div>
          <div class="taskCreateInfo">
            <div class="label">创建时间:</div>
            <div class="content">{{ taskForm.created_at }}</div>
            <div class="label">提交账号:</div>
            <div class="content">{{ taskForm.user_no }}</div>
          </div>
          <div class="seperate"></div>
        </div>
        <div class="formTaskDetail taskPlanNewTaskContainer">
          <el-form
            ref="taskForm"
            :model="taskForm"
            :disabled="true"
            @submit.native.prevent
          >
            <div class="firstRow">
              <el-form-item label="任务名称" prop="mission_name">
                <el-input
                  class="formInputClass"
                  v-model="taskForm.mission_name"
                  @keyup.enter.native="submit('taskForm')"
                >
                </el-input
              ></el-form-item>
              <div class="right">
                <el-form-item label="优先级" prop="priority">
                  <div class="priorityDiv">
                    <img
                      :src="minimum"
                      class="minimum"
                      @click="choosePriority(1)"
                    />
                    <div class="prioritySeperate"></div>
                    <img
                      :src="secondary"
                      class="secondary"
                      @click="choosePriority(2)"
                    />
                    <div class="prioritySeperate"></div>
                    <img
                      :src="highest"
                      class="highest"
                      @click="choosePriority(3)"
                    />
                  </div>
                </el-form-item>
              </div>
            </div>
            <div class="row">
              <el-form-item label="预计发货时间" prop="appointment_delivery_at">
                <el-date-picker
                  popper-class="datePickerClass"
                  class="formInputClass"
                  v-model="taskForm.appointment_delivery_at"
                  type="datetime"
                  placeholder="请选择预计发货时间"
                >
                </el-date-picker>
              </el-form-item>
              <div class="right">
                <el-form-item
                  label="预计收货时间"
                  prop="appointment_receive_at"
                >
                  <el-date-picker
                    popper-class="datePickerClass"
                    class="formInputClass"
                    v-model="taskForm.appointment_receive_at"
                    type="datetime"
                    placeholder="请选择预计收货时间"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="sendUserInfo" style="background: #0083fd">
              <div class="descOfSendUser">投送信息（发送方）</div>
              <div class="addressInfo">
                <div class="chooseAddress">
                  <div class="historyAddress">历史地址</div>
                  <div class="editIcon"></div>
                </div>
                <div
                  :class="customerAddressShowClassName"
                  @click="changeDetailShow(1)"
                ></div>
              </div>
            </div>
            <div class="rowAddress" v-show="customerAddressShow">
              <el-form-item label="补堆名称" prop="customer_company">
                <el-input
                  class="formThreeInputClass"
                  v-model="taskForm.customer_company"
                  disabled
                >
                </el-input
              ></el-form-item>
              <el-form-item label="发货地址" prop="customer_address">
                <el-input
                  class="formThreeInputClass"
                  v-model="taskForm.customer_address"
                  disabled
                >
                </el-input
              ></el-form-item>
              <div class="right">
                <el-form-item label="发货战区" prop="station_id">
                  <el-cascader
                    popper-class="cascaderClass"
                    class="formThreeInputClass"
                    v-model="taskForm.station_id"
                    :options="stations"
                    :props="{
                      expandTrigger: 'hover',
                      value: 'id',
                      label: 'value',
                    }"
                    @change="handleChange"
                  >
                    <template slot-scope="{ data }">
                      <span class="stations">{{ data.value }}</span>
                    </template>
                  </el-cascader>
                </el-form-item>
              </div>
            </div>
            <div class="row" v-show="customerAddressShow">
              <el-form-item label="联系人" prop="customer_name">
                <el-input
                  class="formInputClass"
                  v-model="taskForm.customer_name"
                  disabled
                >
                </el-input
              ></el-form-item>
              <div class="right">
                <el-form-item label="联系方式" prop="customer_phone">
                  <el-input
                    class="formInputClass"
                    v-model="taskForm.customer_phone"
                    disabled
                  >
                  </el-input
                ></el-form-item>
              </div>
            </div>
            <div class="sendUserInfo" style="background: #ffa63e">
              <div class="descOfSendUser">投送信息（接收方）</div>
              <div class="addressInfo">
                <div class="chooseAddress">
                  <div class="historyAddress">历史地址</div>
                  <div class="editIcon"></div>
                </div>
                <div
                  :class="destinationAddressShowClassName"
                  @click="changeDetailShow(2)"
                ></div>
              </div>
            </div>
            <div class="rowAddress" v-show="destinationAddressShow">
              <el-form-item label="补堆名称" prop="destination_company">
                <el-input
                  class="formInputClass"
                  v-model="taskForm.destination_company"
                  disabled
                >
                </el-input
              ></el-form-item>
              <div class="right">
                <el-form-item label="收货地址" prop="destination_address">
                  <el-input
                    class="formInputClass"
                    v-model="taskForm.destination_address"
                    disabled
                  >
                  </el-input
                ></el-form-item>
              </div>
            </div>
            <div class="row" v-show="destinationAddressShow">
              <el-form-item label="联系人" prop="destination_name">
                <el-input
                  class="formInputClass"
                  v-model="taskForm.destination_name"
                  disabled
                >
                </el-input
              ></el-form-item>
              <div class="right">
                <el-form-item label="联系方式" prop="destination_phone">
                  <el-input
                    class="formInputClass"
                    v-model="taskForm.destination_phone"
                    disabled
                  >
                  </el-input
                ></el-form-item>
              </div>
            </div>
            <div class="sendUserInfo" style="background: #0083fd">
              <el-checkbox
                v-model="taskForm.need_take_delivery"
                class="descOfSendUser"
                >是否需要取货</el-checkbox
              >
              <div class="addressInfo">
                <div
                  :class="ifNeedPickUpInfoShowClassName"
                  @click="changeDetailShow(3)"
                ></div>
              </div>
            </div>
            <div class="rowAddress" v-show="ifNeedPickUpInfoShow">
              <el-form-item label="指派货勤">
                <el-select
                  v-model="taskForm.receiverName"
                  popper-class="selectPopperClass"
                >
                  <el-option
                    v-for="user in users"
                    :key="user.id"
                    :label="user.username"
                    :value="user"
                  />
                </el-select>
              </el-form-item>
              <div class="right">
                <el-form-item label="联系方式">
                  <el-input
                    class="formInputClass"
                    disabled
                    v-model="taskForm.receiverPhone"
                  >
                  </el-input
                ></el-form-item>
              </div>
            </div>
            <div class="row" v-show="ifNeedPickUpInfoShow">
              <el-form-item label="取货时间" prop="receiver_at">
                <el-date-picker
                  popper-class="datePickerClass"
                  class="formInputClass"
                  v-model="taskForm.receiver_at"
                  type="datetime"
                  placeholder="请选择取货时间"
                >
                </el-date-picker
              ></el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div class="centerBottomDiv" v-if="null !== addPermission">
        <el-button class="yellowButton" @click="createPlan">{{
          addPermission.name
        }}</el-button>
      </div>
    </div>
    <div class="rightDiv" v-show="newTaskDemandDisplay">
      <div class="rightTopDiv">
        <div class="formTitle">
          <div class="taskIcon">
            <el-image :src="goodsIcon" class="goodsIcon" />
          </div>
          <div class="goodsInfo">
            <div class="goodsName">货物名称</div>
            <el-input
              class="goodsNameInput"
              v-model="goodsName"
              placeholder="请输入货物名称"
              maxlength="50"
              @keyup.enter.native="submit('taskForm')"
              disabled
            ></el-input>
          </div>
        </div>
        <div class="goodsAttribute" id="goodsAttribute">
          <el-image :src="goodsNumIcon" class="goodsNumIcon" />
          <div class="goodsNum">件数&nbsp;(最多30)</div>
          <el-input-number
            v-model="goodsTotalNum"
            @change="handleGoodsNumChange"
            :min="0"
            :max="30"
            size="mini"
            style="width: 90px"
            label=""
            :disabled="true"
          ></el-input-number>
          <el-image :src="goodsWeightIcon" class="goodsWeightIcon" />
          <div class="goodsNum">总重量</div>
          <div id="goodsWeight" class="goodsWeight">
            <el-input v-model="goodsTotalWeight" disabled></el-input>
            <div class="unit">Kg</div>
          </div>
        </div>
        <div class="sendUserInfoes">
          <div class="title">货物信息</div>
          <el-table
            ref="goodsList"
            height="289"
            class="goodsList taskPlanCommonTable forbiddenEventTable"
            :data="goodsList"
            :header-cell-style="tableHeaderColor"
            :cell-style="changeCellStyle"
            :row-class-name="goodsListRowClassName"
          >
            <el-table-column
              label="序号"
              align="center"
              prop="index"
              width="50"
            ></el-table-column>
            <el-table-column
              label="货物编号"
              min-width="150"
              align="center"
              prop="local_id"
            >
            </el-table-column>
            <el-table-column
              label="体积（长*宽*高）/厘米"
              align="center"
              min-width="330"
            >
              <template slot-scope="scope" id="volume" class="volume">
                <el-input-number
                  v-model="goodsList[scope.row.index - 1].goods_length"
                  controls-position="right"
                  :min="1"
                  :max="10000"
                  size="mini"
                  style="width: 100px"
                  @keyup.enter.native="submit('taskForm')"
                ></el-input-number>
                <el-input-number
                  v-model="goodsList[scope.row.index - 1].goods_width"
                  controls-position="right"
                  :min="1"
                  :max="10000"
                  size="mini"
                  style="width: 100px"
                  @keyup.enter.native="submit('taskForm')"
                ></el-input-number>
                <el-input-number
                  v-model="goodsList[scope.row.index - 1].goods_height"
                  controls-position="right"
                  :min="1"
                  :max="10000"
                  size="mini"
                  style="width: 100px"
                  @keyup.enter.native="submit('taskForm')"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              label="重量/Kg"
              align="center"
              prop="goods_weight"
              min-width="120"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="goodsList[scope.row.index - 1].goods_weight"
                  controls-position="right"
                  :min="1"
                  :max="10000"
                  size="mini"
                  style="width: 100px"
                  @change="countTotalWeight"
                  @keyup.enter.native="submit('taskForm')"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              label="属性"
              min-width="280"
              align="center"
              prop="attribute"
            >
              <template slot-scope="scope">
                <el-checkbox-group
                  v-model="goodsList[scope.row.index - 1].attribute"
                  class="attributes"
                >
                  <el-checkbox
                    v-for="(item, index) in attributes"
                    :key="index"
                    :label="item"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
              </template>
            </el-table-column>
            <el-table-column
              label="类型"
              min-width="150"
              align="center"
              prop="goods_type_id"
              ><template slot-scope="scope">
                <el-select
                  v-model="goodsList[scope.row.index - 1].goods_type_id"
                  popper-class="selectPopperClass"
                  disabled
                >
                  <el-option
                    v-for="goodsType in goodsTypes"
                    :key="goodsType.id"
                    :label="goodsType.name"
                    :value="goodsType.id"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="包装"
              min-width="150"
              align="center"
              prop="goods_package_id"
              ><template slot-scope="scope">
                <el-select
                  popper-class="selectPopperClass"
                  v-model="goodsList[scope.row.index - 1].goods_package_id"
                  disabled
                >
                  <el-option
                    v-for="goodsPackage in goodsPackages"
                    :key="goodsPackage.id"
                    :label="goodsPackage.name"
                    :value="goodsPackage.id"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="密级"
              min-width="120"
              align="center"
              prop="goods_secrecy_id"
              ><template slot-scope="scope">
                <el-select
                  popper-class="selectPopperClass"
                  v-model="goodsList[scope.row.index - 1].goods_secrecy_id"
                  disabled
                >
                  <el-option
                    v-for="goodsSecrecy in goodsSecrecies"
                    :key="goodsSecrecy.id"
                    :label="goodsSecrecy.name0 + goodsSecrecy.name1"
                    :value="goodsSecrecy.id"
                  />
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- <el-input
        placeholder="备注"
        type="textarea"
        class="rightCenterDiv"
        v-model="taskForm.note"
        :disabled="isDetail"
        @input="change($event)"
      ></el-input> -->
      <div class="rightCenterDiv">
        <div class="historyButton">
          <div
            :class="isHistory ? 'remarkClassNow' : 'remarkClassHistory'"
            @click="isHistory = true"
          >
            历史备注
          </div>
        </div>
        <div class="historyRemark">
          <span v-for="(item, index) in taskForm.historyNote" :key="index">
            {{ item }}<br />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import taskIcon from "../../../assets/img/home/task.png";
import goodsIcon from "../../../assets/img/home/goods.png";
import goodsNumIcon from "../../../assets/img/home/goodsNum.png";
import goodsWeightIcon from "../../../assets/img/home/goodsWeight.png";
import minimum from "../../../assets/img/home/minimum.png";
import minimumUnchecked from "../../../assets/img/home/minimumUnchecked.png";
import secondary from "../../../assets/img/home/secondary.png";
import secondaryUnchecked from "../../../assets/img/home/secondaryUnchecked.png";
import highest from "../../../assets/img/home/highest.png";
import highestUnchecked from "../../../assets/img/home/highestUnchecked.png";
import JsBarcode from "jsbarcode";
import tooltipOver from "../../tools/tooltipOver";

const newTaskProgress = "newTaskProgress";
const planningProgress = "planningProgress";
const submittedProgress = "submittedProgress";
const rejectedProgress = "rejectedProgress";

export default {
  name: "newTaskPlanning",
  props: [
    "userInfo",
    "opacityInfos",
    "numInfos",
    "currentProgress",
    "addPermission",
  ],
  data() {
    return {
      selectMissionId: null,
      newTaskDemandDisplay: false,
      rightTopDiv: "rightTopDiv",
      goodsListHeight: 289,
      taskTotalNum: 258,
      waitPickUpNum: 56,
      submittedTodayNum: 10,
      opacityOfTotalTask: "opacity: 1;",
      opacityOfWaitPickUp: "opacity: 0.4;",
      opacityOfSubmittedToday: "opacity: 0.4;",
      minimum: minimumUnchecked,
      secondary: secondaryUnchecked,
      highest: highestUnchecked,
      loadTaskSign: true,
      loadingTask: false,
      totalTaskPage: 6,
      queryTaskForm: {
        mission_name: "",
        priority: "",
        mission_status: 20,
        created_at: "",
        is_removed: 0,
        currentpage: 1,
        pagesize: 0,
      },
      newTaskList: [],
      taskIcon: taskIcon,
      goodsIcon: goodsIcon,
      goodsNumIcon: goodsNumIcon,
      goodsWeightIcon: goodsWeightIcon,
      taskForm: {
        id: "",
        local_id: "0000000-0000",
        mission_name: "",
        priority: "",
        customer_company: "",
        customer_name: "",
        customer_phone: "",
        customer_address: "",
        area_id: "",
        station_id: "",

        destination_company: "",
        destination_name: "",
        destination_phone: "",
        destination_address: "",

        appointment_delivery_at: "",
        appointment_receive_at: "",
        need_take_delivery: false,

        receiver_id: "",
        receiverName: "",
        receiverPhone: "",

        receiver_at: "",
        mission_status: "",
        historyNote: "",
        note: "",
        user_id: "",
        created_at: "",
        is_removed: 0,
      },
      isHistory: true,
      replaceStr: "$", //分隔符
      // 表单验证
      taskFormRules: {},
      goodsTotalNum: 0,
      goodsNum: 0,
      // 货物总重量
      goodsTotalWeight: 0,
      // 货物名称
      goodsName: "",
      // 货物列表
      goodsList: [],
      multipleSelection: [],
      customerAddressShowClassName: "downArrow",
      customerAddressShow: true,
      destinationAddressShowClassName: "downArrow",
      destinationAddressShow: true,
      ifNeedPickUpInfoShowClassName: "downArrow",
      ifNeedPickUpInfoShow: true,
      listDialogVisible: false,
      editDialogVisible: false,
      dialogName: "新增发货地址信息",
      dialogClassName: "sendAddressViewDialog",
      // 是否为收货地址
      isCustomerAddress: true,
      // 发货地址列表
      customerAddressData: [],
      // 发货地址表单
      customerAddressForm: {
        id: "",
        customer_company: "",
        customer_name: "",
        customer_phone: "",
        customer_address: "",
        area_id: "",
        area_name: "",
        station_id: "",
        station_name: "",
        is_default: "1",
      },
      // 收货地址列表
      destinationAddressData: [],
      // 收货地址表单
      destinationAddressForm: {
        id: "",
        destination_company: "",
        destination_name: "",
        destination_phone: "",
        destination_address: "",
        is_default: "1",
      },
      // 任务表单class属性
      formClass: "form",
      // 是否是查看详情
      isDetail: false,
      // 是否是待取货状态
      inWaitPickUp: false,
      // 属性
      attributes: [
        {
          id: "0",
          label: "易碎性",
        },
        {
          id: "1",
          label: "易爆性",
        },
        {
          id: "2",
          label: "易燃性",
        },
        {
          id: "3",
          label: "腐蚀性",
        },
      ],
      // 类型
      goodsTypes: [],
      // 包装
      goodsPackages: [],
      // 密级
      goodsSecrecies: [
        {
          id: 0,
          name0: "非",
          name1: "密",
        },
        {
          id: 1,
          name0: "秘",
          name1: "密",
        },
        {
          id: 2,
          name0: "机",
          name1: "密",
        },
        {
          id: 3,
          name0: "绝",
          name1: "密",
        },
      ],
      stations: [], //战区
      users: [], //用户
    };
  },
  components: {
    "tooltip-over": tooltipOver,
  },
  methods: {
    change(e) {
      this.$forceUpdate();
    },
    showMore(val) {
      this.$confirm(val, "", {
        confirmButtonText: "好的",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        showCancelButton: false,
      });
    },
    newTask() {
      this.$emit("progressChange", newTaskProgress);
    },
    planning() {
      this.$emit("progressChange", planningProgress);
    },
    submitted() {
      this.$emit("progressChange", submittedProgress);
    },
    rejected() {
      this.$emit("progressChange", rejectedProgress);
    },

    totalTask() {
      this.opacityOfTotalTask = "opacity: 1;";
      this.opacityOfWaitPickUp = "opacity: 0.4;";
      this.opacityOfSubmittedToday = "opacity: 0.4;";
      this.queryTaskForm.created_at = "";
      this.queryTaskForm.mission_status = "";
      this.queryTaskByCondition();
    },
    waitPickUp() {
      this.opacityOfTotalTask = "opacity: 0.4;";
      this.opacityOfWaitPickUp = "opacity: 1;";
      this.opacityOfSubmittedToday = "opacity: 0.4;";
      this.queryTaskForm.created_at = "";
      this.queryTaskForm.mission_status = 10;
      this.queryTaskByCondition();
    },
    submittedToday() {
      this.opacityOfTotalTask = "opacity: 0.4;";
      this.opacityOfWaitPickUp = "opacity: 0.4;";
      this.opacityOfSubmittedToday = "opacity: 1;";
      let date = new Date();
      this.queryTaskForm.created_at = this.$moment(date).format("YYYY-MM-DD");
      this.queryTaskForm.mission_status = "";
      this.queryTaskByCondition();
    },
    changeDetailShow(val) {
      if (1 === val) {
        this.customerAddressShow = !this.customerAddressShow;
        if (this.customerAddressShow) {
          this.customerAddressShowClassName = "downArrow";
        } else {
          this.customerAddressShowClassName = "downArrowAfter";
        }
      } else if (2 === val) {
        this.destinationAddressShow = !this.destinationAddressShow;
        if (this.destinationAddressShow) {
          this.destinationAddressShowClassName = "downArrow";
        } else {
          this.destinationAddressShowClassName = "downArrowAfter";
        }
      } else if (3 === val) {
        this.ifNeedPickUpInfoShow = !this.ifNeedPickUpInfoShow;
        if (this.ifNeedPickUpInfoShow) {
          this.ifNeedPickUpInfoShowClassName = "downArrow";
        } else {
          this.ifNeedPickUpInfoShowClassName = "downArrowAfter";
        }
      }
    },
    chooseCustomerAddress(val) {
      if (this.isDetail && !this.inWaitPickUp) {
      } else {
        this.listDialogVisible = true;
        if (1 === val) {
          this.isCustomerAddress = true;
          this.$nextTick(() => {
            this.getCustomerList();
          });
        } else if (2 === val) {
          this.isCustomerAddress = false;
          this.$nextTick(() => {
            this.getDestinationList();
          });
        }
      }
    },
    confirmAddress() {
      this.listDialogVisible = false;
      if (this.isCustomerAddress) {
        let customerAddressForm = this.customerAddressForm;
        this.setCustomerAddressForm();
      } else {
        let destinationAddressForm = this.destinationAddressForm;
        this.setDestinationAddressForm();
      }
    },
    operateAddress(item) {
      this.editDialogVisible = true;
      let isCustomerAddress = this.isCustomerAddress;
      if (item) {
        if (isCustomerAddress) {
          this.dialogName = "编辑发货地址信息";
          this.dialogClassName = "sendAddressViewDialog";
          this.customerAddressForm = item;
          if (this.customerAddressForm.is_default) {
            this.customerAddressForm.is_default = String(
              this.customerAddressForm.is_default
            );
          }
        } else {
          this.dialogName = "编辑收货地址信息";
          this.dialogClassName = "reciAddressViewDialog";
          this.destinationAddressForm = item;
          if (this.destinationAddressForm.is_default) {
            this.destinationAddressForm.is_default = String(
              this.destinationAddressForm.is_default
            );
          }
        }
      } else {
        if (isCustomerAddress) {
          this.customerAddressForm = {
            id: "",
            customer_company: "",
            customer_name: "",
            customer_phone: "",
            customer_address: "",
            area_id: "",
            area_name: "",
            station_id: "",
            station_name: "",
            is_default: "1",
          };
          this.dialogName = "新增发货地址信息";
          this.dialogClassName = "sendAddressViewDialog";
        } else {
          this.destinationAddressForm = {
            id: "",
            destination_company: "",
            destination_name: "",
            destination_phone: "",
            destination_address: "",
            is_default: "1",
          };
          this.dialogName = "新增收货地址信息";
          this.dialogClassName = "reciAddressViewDialog";
        }
      }
      this.$nextTick(() => {
        this.initCascaderStyle();
      });
    },
    saveAddress() {
      let isCustomerAddress = this.isCustomerAddress;
      let formName = "destinationAddressForm";
      if (isCustomerAddress) {
        formName = "customerAddressForm";
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (isCustomerAddress) {
            if (this.customerAddressForm.id) {
              this.updateCustomer();
            } else {
              this.addCustomer();
            }
          } else {
            if (this.destinationAddressForm.id) {
              this.updateDestination();
            } else {
              this.addDestination();
            }
          }
        }
      });
    },
    // 新增发货地址
    addCustomer() {
      this.postJsonRequest(
        "/uav-task-server/customer/addCustomer.do",
        this.customerAddressForm
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.listDialogVisible = false;
          this.editDialogVisible = false;
          this.setCustomerAddressForm();
        } else if (oData.code != 401) {
          this.confirmMessage(oData.msg);
        }
      });
    },
    // 获取发货地址列表
    getCustomerList() {
      this.getRequest(
        "/uav-task-server/customer/getCustomerList.do?currentpage=1&pagesize=0"
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            let list = data.list;
            this.customerAddressData = list;
            if (list && list.length > 0) {
              this.customerAddressForm = list[0];
            }
          }
        } else if (oData.code != 401) {
          this.confirmMessage("发货地址获取失败~");
        }
      });
    },
    // 删除发货地址信息
    delCustomer(item) {
      let tips = "<i class='el-icon-warn-tip'></i>确定删除该地址信息?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      })
        .then(() => {
          this.postJsonRequest(
            "/uav-task-server/customer/delCustomer.do",
            item
          ).then((res) => {
            let oData = res.data;
            if (oData.code === 0) {
              this.getCustomerList();
            } else if (oData.code != 401) {
              this.confirmMessage(oData.msg);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 修改发货地址
    updateCustomer() {
      this.postJsonRequest(
        "/uav-task-server/customer/updateCustomer.do",
        this.customerAddressForm
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.listDialogVisible = false;
          this.editDialogVisible = false;
          this.setCustomerAddressForm();
        } else if (oData.code != 401) {
          this.confirmMessage(oData.msg);
        }
      });
    },
    // 设置任务发货地址
    setCustomerAddressForm() {
      this.taskForm.customer_company = this.customerAddressForm.customer_company;
      this.taskForm.customer_name = this.customerAddressForm.customer_name;
      this.taskForm.customer_phone = this.customerAddressForm.customer_phone;
      this.taskForm.customer_address = this.customerAddressForm.customer_address;
      this.taskForm.area_id = this.customerAddressForm.area_id;
      this.taskForm.station_id = this.customerAddressForm.station_id;
      this.$refs.taskForm.validateField("customer_company");
      this.$refs.taskForm.validateField("customer_name");
      this.$refs.taskForm.validateField("customer_phone");
      this.$refs.taskForm.validateField("customer_address");
      this.$refs.taskForm.validateField("area_id");
      this.$refs.taskForm.validateField("station_id");
    },
    // 新增收货地址
    addDestination() {
      this.postJsonRequest(
        "/uav-task-server/customer/addDestination.do",
        this.destinationAddressForm
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.listDialogVisible = false;
          this.editDialogVisible = false;
          this.setDestinationAddressForm();
        } else if (oData.code != 401) {
          this.confirmMessage(oData.msg);
        }
      });
    },
    // 获取收货地址列表
    getDestinationList() {
      this.getRequest(
        "/uav-task-server/customer/getDestinationList.do?currentpage=1&pagesize=0"
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            let list = data.list;
            this.destinationAddressData = list;
            if (list && list.length > 0) {
              this.destinationAddressForm = list[0];
            }
          }
        } else if (oData.code != 401) {
          this.confirmMessage("收货地址获取失败~");
        }
      });
    },
    // 删除收货地址信息
    delDestination(item) {
      let tips = "<i class='el-icon-warn-tip'></i>确定删除该地址信息?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      })
        .then(() => {
          this.postJsonRequest(
            "/uav-task-server/customer/delDestination.do",
            item
          ).then((res) => {
            let oData = res.data;
            if (oData.code === 0) {
              this.getDestinationList();
            } else if (oData.code != 401) {
              this.confirmMessage(oData.msg);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 修改收货地址
    updateDestination() {
      this.postJsonRequest(
        "/uav-task-server/customer/updateDestination.do",
        this.destinationAddressForm
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.listDialogVisible = false;
          this.editDialogVisible = false;
          this.setDestinationAddressForm();
        } else if (oData.code != 401) {
          this.confirmMessage(oData.msg);
        }
      });
    },
    // 设置任务收货地址
    setDestinationAddressForm() {
      this.taskForm.destination_company = this.destinationAddressForm.destination_company;
      this.taskForm.destination_name = this.destinationAddressForm.destination_name;
      this.taskForm.destination_phone = this.destinationAddressForm.destination_phone;
      this.taskForm.destination_address = this.destinationAddressForm.destination_address;

      this.$refs.taskForm.validateField("destination_company");
      this.$refs.taskForm.validateField("destination_name");
      this.$refs.taskForm.validateField("destination_phone");
      this.$refs.taskForm.validateField("destination_address");
    },
    choosePriority(priority, ifNotValid) {
      if (this.isDetail && !this.inWaitPickUp) {
      } else {
        this.taskForm.priority = priority;
        if (1 === priority) {
          this.minimum = minimum;
          this.secondary = secondaryUnchecked;
          this.highest = highestUnchecked;
        } else if (2 === priority) {
          this.minimum = minimumUnchecked;
          this.secondary = secondary;
          this.highest = highestUnchecked;
        } else if (3 === priority) {
          this.minimum = minimumUnchecked;
          this.secondary = secondaryUnchecked;
          this.highest = highest;
        } else {
          this.minimum = minimumUnchecked;
          this.secondary = secondaryUnchecked;
          this.highest = highestUnchecked;
        }
        if (!ifNotValid) {
          this.$refs.taskForm.validateField("priority");
        }
      }
    },
    getUsers() {
      this.postJsonRequest(
        "/user-server/api/u-user/query?current=1&size=-1",
        {}
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            this.users = data.records;
          }
        } else if (oData.code != 401) {
          this.confirmMessage("用户获取失败~");
        }
      });
    },
    changeUser(user) {
      this.taskForm.receiver_id = user.id;
      this.taskForm.receiverName = user.username;
      this.taskForm.receiverPhone = user.phone;
    },
    getStations() {
      this.getRequest(
        "/basic-info-server/station/getStationGroupByArea.do"
      ).then((res) => {
        let oData = res.data;
        if (0 === oData.code) {
          let data = oData.data;

          if (!this.isEmptyArray(data)) {
            this.stations = this.resetStation(data);
          } else {
            this.stations = [];
          }
        } else if (oData.code != 401) {
          this.confirmMessage("获取战区失败~");
        }
      });
    },
    resetStation(data) {
      if (!this.isEmptyArray(data)) {
        data.forEach((element) => {
          if (!this.isEmptyArray(element.children)) {
            element.children.forEach((e) => {
              e.id = e.id;
              e.value = e.name;
            });
          }
        });
      }
      return data;
    },
    handleChange(selectInfo) {
      if (selectInfo) {
        this.taskForm.name = selectInfo[1];
      }
    },
    //历史地址 发货地址发货战区修改
    handleAddressChange(selectInfo) {
      if (selectInfo && selectInfo.length > 1) {
        this.customerAddressForm.area_id = selectInfo[0];
        this.customerAddressForm.station_id = selectInfo[1];
      }
    },
    // 发货件数修改
    handleGoodsNumChange(val) {
      let old = this.goodsNum;
      let difference = old - val;
      if (difference > 0) {
        this.handleDeleteGoods(difference);
      } else if (difference < 0) {
        difference = Math.abs(difference);
        for (let i = 0; i < difference; i++) {
          this.handleAddGoods();
        }
      }
      this.goodsNum = val;
      this.$nextTick(() => {
        this.countTotalWeight();
      });
    },
    handleAddGoods() {
      if (undefined == this.goodsList) {
        this.goodsList = new Array();
      }
      let obj = {};
      obj.local_id = "";
      obj.mission_id = this.taskForm.id;
      obj.goods_length = "";
      obj.goods_width = "";
      obj.goods_height = "";
      obj.goods_volume = "";
      obj.goods_weight = "";
      obj.goods_attribute_id = "";
      obj.goods_type_id = "";
      obj.goods_package_id = "";
      obj.goods_secrecy_id = "";
      obj.goods_inflammable_id = 0;
      obj.goods_attribute_id = 0;
      obj.goods_explosible_id = 0;
      obj.goods_cautery_id = 0;
      obj.attribute = [];

      this.goodsList.push(obj);
    },
    handleDeleteGoods(difference) {
      let len = this.goodsList.length;
      if (len > 0) {
        for (
          let index = len - 1, j = 0;
          index >= 0 && j < difference;
          index--, j++
        ) {
          this.goodsList.splice(index, 1);
        }
      }
    },
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    countTotalWeight() {
      let goodsList = this.goodsList;
      if (goodsList.length > 0) {
        let goodsWeight = 0;
        for (let i = 0, len = goodsList.length; i < len; i++) {
          goodsWeight += goodsList[i].goods_weight;
        }
        this.goodsTotalWeight = goodsWeight;
      }
    },
    initCascaderStyle() {
      let scrollbars = document.getElementsByClassName("el-scrollbar");
      if (scrollbars && scrollbars.length > 0) {
        for (let i = 0, len = scrollbars.length; i < len; i++) {
          scrollbars[i].style.background = "rgb(28, 35, 64)";
          scrollbars[i].style.border = "1px solid rgb(20, 107, 249)";
          scrollbars[i].style.boxShadow = "rgba(0, 0, 0, 0.41) 0px 3px 9px 0px";
          scrollbars[i].style.borderRadius = "3px";
        }
      }
    },
    getQueryParam(form) {
      let param = "";
      if (form) {
        for (const key in form) {
          if (form.hasOwnProperty(key)) {
            const element = form[key];
            if (
              null !== element &&
              undefined !== element &&
              0 < ("" + element).length
            ) {
              param += "&" + key + "=" + element;
            }
          }
        }
      }
      return param;
    },
    // 获取货物类别
    getGoodsTypeList() {
      this.getRequest("/uav-task-server/goodstype/getGoodsTypeList.do").then(
        (res) => {
          let oData = res.data;
          if (oData.code == 0) {
            this.goodsTypes = oData.data;
          } else if (oData.code != 401) {
            this.confirmMessage("货物类别获取失败~");
          }
        }
      );
    },
    // 获取货物包装
    getGoodsPackageList() {
      this.getRequest(
        "/uav-task-server/goodpackage/getGoodsPackageList.do"
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.goodsPackages = oData.data;
        } else if (oData.code != 401) {
          this.confirmMessage("货物包装获取失败~");
        }
      });
    },
    // 查询任务
    queryTask() {
      this.getRequest(
        "/uav-task-server/mission/getMissionList.do?" +
          this.getQueryParam(this.queryTaskForm)
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          this.newTaskList = this.newTaskList = data.list;
          this.$emit("newMissionCountChange", this.newTaskList.length);
        } else if (oData.code != 401) {
          this.confirmMessage("任务列表获取失败~");
        }
      });
    },
    // 根据条件查询任务
    queryTaskByCondition() {
      this.newTaskList = [];
      this.queryTaskForm.currentpage = 1;
      this.queryTask();
    },
    // 加载更多任务
    loadMoreTask() {
      if (this.loadTaskSign) {
        this.loadTaskSign = false;
        this.loadingTask = false;
        this.queryTaskForm.currentpage++;
        if (this.queryTaskForm.currentpage > this.totalTaskPage) {
          return;
        }
        this.loadTaskSign = true;
        this.loadingTask = true;
        this.queryTask();
        console.log("到底了", this.queryTaskForm.currentpage);
      }
    },
    // 点击任务列表
    clickTaskRow(row) {
      this.$set(this.$data, "selectMissionId", row.id); //当前选择的任务id
      this.$refs.newTaskList.toggleRowSelection(row, true);
      this.initCascaderStyle();
      this.getStations();
      this.getUsers();
      this.getGoodsTypeList();
      this.getGoodsPackageList();
      if (undefined !== row.priority) {
        this.choosePriority(Number(row.priority), true);
      }
      this.formClass = "formTaskDetail";
      this.isDetail = true;
      if (row.mission_status === 20) {
        this.$data.newTaskDemandDisplay = true;
        this.rightTopDiv = "rightTopDiv";
        this.goodsListHeight = 289;
      } else {
        this.$data.newTaskDemandDisplay = false;
        this.rightTopDiv = "rightTopDisableDiv";
        this.goodsListHeight = 383;
      }
      this.$nextTick(() => {
        this.getMissionById(row.id);
      });
    },
    // 获取任务详情
    getMissionById(id) {
      this.postJsonRequest("/uav-task-server/mission/getMissionById.do", {
        id,
      }).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.taskForm = oData.data;
          let note = this.taskForm.note;
          if (note) {
            let notes = note.split(this.replaceStr);
            if (notes && notes.length > 0) {
              let notee = [];
              notes.forEach((item) => {
                if (item) {
                  notee.push(item);
                }
              });
              this.taskForm.historyNote = notee;
            } else {
              this.taskForm.historyNote = "";
            }
          } else {
            this.taskForm.historyNote = "";
          }
          this.createCode(this.taskForm.local_id);
          this.dealDataAfterGetDetail();
        } else if (oData.code != 401) {
          this.confirmMessage(oData.msg);
        }
      });
    },
    // 生成条形码
    createCode(localId) {
      JsBarcode("#barCode", localId, {
        format: "CODE39", //条形码的格式
        lineColor: "#ffffff", //线条颜色
        width: 1, //线宽
        height: 25, //条码高度
        displayValue: true, //是否在条形码下方显示文字
        background: "transparent", //背景色
        font: "ArialMT", //设置文本的字体
        textMargin: 5, //设置条形码和文本之间的间距
        fontSize: "12", //设置文本的大小
        margin: 10, //设置条形码周围的空白边距
      });
    },
    // 获取详情后 数据处理
    dealDataAfterGetDetail() {
      let need_take_delivery = this.taskForm.need_take_delivery;
      if (undefined !== need_take_delivery) {
        if (1 === Number(need_take_delivery)) {
          this.taskForm.need_take_delivery = true;
        } else {
          this.taskForm.need_take_delivery = false;
        }
      }
      // 设置货物列表信息 start
      let goodsList = this.taskForm.goods;
      if (goodsList && goodsList.length > 0) {
        let _this = this;
        _this.goodsName = goodsList[0].goods_name;
        let attributes = _this.attributes;
        goodsList.forEach(function (goods, index) {
          let attribute = [];
          let goods_attribute_id = goods.goods_attribute_id;
          if (goods_attribute_id && 1 === Number(goods_attribute_id)) {
            attribute.push(attributes[0]);
          }
          let goods_explosible_id = goods.goods_explosible_id;
          if (goods_explosible_id && 1 === Number(goods_explosible_id)) {
            attribute.push(attributes[1]);
          }
          let goods_inflammable_id = goods.goods_inflammable_id;
          if (goods_inflammable_id && 1 === Number(goods_inflammable_id)) {
            attribute.push(attributes[2]);
          }
          let goods_cautery_id = goods.goods_cautery_id;
          if (goods_cautery_id && 1 === Number(goods_cautery_id)) {
            attribute.push(attributes[3]);
          }
          _this.$set(goods, "attribute", attribute); //触发更新视图
        });
        _this.goodsList = goodsList;
        _this.goodsTotalNum = goodsList.length;
        _this.goodsNum = goodsList.length;
      } else {
        this.goodsList = [];
        this.goodsTotalNum = 0;
        this.goodsNum = 0;
      }
      this.$nextTick(() => {
        this.countTotalWeight();
      });
      // 设置货物列表信息 end
      // 设置指派货勤信息
      let users = this.users;
      if (users && users.length > 0) {
        let receiver_id = this.taskForm.receiver_id;
        if (receiver_id) {
          for (let i = 0, len = users.length; i < len; i++) {
            let user = users[i];
            if (receiver_id === user.id) {
              this.changeUser(user);
              break;
            }
          }
        }
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#0083FD;color:#FFFFFF;font-weight:500;font-family:AlibabaPuHuiTiM;font-size: 14px;height:30px;border-bottom:none;border-left: 1px solid #020B19;";
      }
    },
    changeCellStyle(row, column, rowIndex, columnIndex) {
      if (row.column.label === "优先级") {
        return "color:#FFA63E"; //修改的样式
      } else {
        return "color:#FFFFFF";
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.$data.selectMissionId === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },
    goodsListRowClassName({ row, rowIndex }) {
      row.index = rowIndex + 1;
      return "rowStyle";
    },
    // 添加任务按钮
    addClick() {
      this.inWaitPickUp = false;
      this.isDetail = false;
      this.rightTopDiv = "rightTopDiv";
      this.goodsListHeight = 289;
      this.formClass = "form";
      this.restParams();
    },
    restParams() {
      // 重置表单内容
      this.taskForm = {
        id: "",
        local_id: "0000000-0000",
        mission_name: "",
        priority: "",
        customer_company: "",
        customer_name: "",
        customer_phone: "",
        customer_address: "",
        area_id: "",
        station_id: "",

        destination_company: "",
        destination_name: "",
        destination_phone: "",
        destination_address: "",

        appointment_delivery_at: "",
        appointment_receive_at: "",
        need_take_delivery: false,

        receiver_id: "",
        receiverName: "",
        receiverPhone: "",

        receiver_at: "",
        mission_status: "",
        note: "",
        user_id: "",
        created_at: "",
      };
      this.goodsList = [];
      this.goodsTotalNum = 0;
      this.goodsNum = 0;
      this.goodsTotalWeight = 0;
      this.goodsName = "";

      this.$nextTick(() => {
        this.initCascaderStyle();
        this.getStations();
        this.getUsers();
        this.getGoodsTypeList();
        this.getGoodsPackageList();
        this.choosePriority(null, true);
      });
    },
    setGoodsInfo() {
      let goodsName = this.goodsName;
      let goodsList = this.goodsList;
      if (goodsList && goodsList.length > 0) {
        goodsList.forEach(function (goods, index) {
          if (goodsName) {
            goods.goods_name = goodsName;
          }
          let attributes = goods.attribute;
          if (attributes.length > 0) {
            let goodsAttributeIndex = attributes.findIndex(
              (item) => item.id === "0"
            );
            if (goodsAttributeIndex === -1) {
              goods.goods_attribute_id = 0;
            } else {
              goods.goods_attribute_id = 1;
            }
            let goodsExplosibleIndex = attributes.findIndex(
              (item) => item.id === "1"
            );
            if (goodsExplosibleIndex === -1) {
              goods.goods_explosible_id = 0;
            } else {
              goods.goods_explosible_id = 1;
            }
            let goodsInflammableIndex = attributes.findIndex(
              (item) => item.id === "2"
            );
            if (goodsInflammableIndex === -1) {
              goods.goods_inflammable_id = 0;
            } else {
              goods.goods_inflammable_id = 1;
            }
            let goodsCauteryIndex = attributes.findIndex(
              (item) => item.id === "3"
            );
            if (goodsCauteryIndex === -1) {
              goods.goods_cautery_id = 0;
            } else {
              goods.goods_cautery_id = 1;
            }
          } else {
            goods.goods_attribute_id = 0;
            goods.goods_explosible_id = 0;
            goods.goods_inflammable_id = 0;
            goods.goods_cautery_id = 0;
          }
        });
      }
    },
    submit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let need_take_delivery = this.taskForm.need_take_delivery;
          if (need_take_delivery) {
            this.taskForm.need_take_delivery = "1";
          } else {
            this.taskForm.need_take_delivery = "0";
          }
          const appointment_delivery_at = this.$moment(
            this.taskForm.appointment_delivery_at
          ).format("YYYY-MM-DD HH:mm:ss");
          const appointment_receive_at = this.$moment(
            this.taskForm.appointment_receive_at
          ).format("YYYY-MM-DD HH:mm:ss");
          let receiver_at = "";
          if (this.taskForm.receiver_at) {
            receiver_at = this.$moment(this.taskForm.receiver_at).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }
          this.setGoodsInfo();
          let params = {
            ...this.taskForm,
            appointment_delivery_at,
            appointment_receive_at,
            receiver_at,
            goods: this.goodsList,
          };
          if (this.taskForm.id) {
            this.updateMission(params);
          } else {
            this.addMission(params);
          }
        }
      });
    },
    // 新增任务
    addMission(params) {
      this.postJsonRequest(
        "/uav-task-server/mission/addMission.do",
        params
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.queryTaskByCondition();
          this.$message({
            message: "提交成功",
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () {},
          });
        } else if (oData.code != 401) {
          this.confirmMessage(oData.msg);
        }
      });
    },
    // 修改任务
    updateMission(params) {
      this.postJsonRequest(
        "/uav-task-server/mission/updateMission.do",
        params
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.queryTaskByCondition();
          this.$message({
            message: "操作成功",
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () {},
          });
        } else if (oData.code != 401) {
          this.confirmMessage(oData.msg);
        }
      });
    },
    concelClick() {
      this.goodsList = [];
      this.restParams();
    },
    deleteClick() {
      let tips = "<i class='el-icon-warn-tip'></i>确定删除该任务?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      })
        .then(() => {
          let need_take_delivery = this.taskForm.need_take_delivery;
          if (need_take_delivery) {
            this.taskForm.need_take_delivery = "1";
          } else {
            this.taskForm.need_take_delivery = "0";
          }
          let params = {
            ...this.taskForm,
            is_removed: 1,
          };
          this.updateMission(params);
          this.concelClick();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    copyClick() {
      this.taskForm = {
        ...this.taskForm,
        id: "",
        local_id: "0000000-0000",
        user_id: "",
      };
      let goodsList = this.goodsList;
      if (goodsList && goodsList.length > 0) {
        goodsList.forEach((goods) => {
          goods.id = "";
          goods.local_id = "";
        });
      }
      this.goodsList = goodsList;
      this.inWaitPickUp = false;
      this.isDetail = false;
      this.rightTopDiv = "rightTopDiv";
      this.goodsListHeight = 289;

      this.formClass = "form";
    },
    createPlan() {
      this.$emit("newPlan", this.$data.selectMissionId);
    },
    confirmMessage(msg) {
      this.$confirm("<i class='el-icon-warn-tip'></i>" + msg, "提示", {
        confirmButtonText: "好的",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        cancelButtonClass: "cancel",
      });
    },
  },
  mounted() {
    this.queryTask();
    if (!window.queryTimer) {
      window.queryTimer = setInterval(this.queryTaskByCondition, 30000); //30秒轮询一次
    }
  },
  watch: {
    currentProgress(nval, oval) {
      if (newTaskProgress == nval) {
        this.$data.newTaskDemandDisplay = false;
      }
    },
  },
  beforeDestroy() {
    if (window.queryTimer) {
      clearInterval(window.queryTimer);
      window.queryTimer = null;
    }
  },
};
</script>

<style scoped>
@import "../../../assets/css/home/TaskPlanning.css";
</style>

<style>
@import "../../../assets/css/home/TaskPlanningGlobal.css";
</style>



// WEBPACK FOOTER //
// src/components/home/taskplan/NewTaskPlanning.vue